<script lang="ts" setup>
import { useClaims } from '@auth/useClaims';
import { useWatchErrorHandler } from '@errors/useErrorHandler';
import type { CrmAdviseursGetAdviseursDto as Adviseur } from '@services/crm-internal/api';
import FadeSlideTransition from '@shared/animation/transitions/FadeSlideTransition/FadeSlideTransition.vue';
import { useId } from '@tools/composables/id';
import { useFieldValue, useForm } from 'vee-validate';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import AdviseurSelectie from '../AdviseurSelectie/AdviseurSelectie.vue';
import { useDomeinen } from './composables/domeinen';
import DomainStatus from './DomainStatus/DomainStatus.vue';
import EmailAuthenticationExplanation from './EmailAuthenticationExplanation/EmailAuthenticationExplanation.vue';

useForm();

const claims = useClaims();
const adviseur = useFieldValue<Adviseur | undefined>('adviseur');
const ids = useId('email-authentication', ['explanation', 'domainStatus']);
const { data: domeinenData, error, isPending } = useDomeinen(() => adviseur.value?.adviseurnummer);

useWatchErrorHandler(error);
</script>

<template>
  <div class="flex flex-col gap-6">
    <AdviseurSelectie v-if="claims.isInternal" />

    <VContentBox>
      <FadeSlideTransition direction="down" group>
        <template v-if="!claims.isInternal || adviseur">
          <EmailAuthenticationExplanation
            :key="ids.explanation"
            :domeinen="domeinenData"
            :is-pending="isPending"
          />

          <DomainStatus :key="ids.domainStatus" :domeinen="domeinenData" :is-pending="isPending" />
        </template>
      </FadeSlideTransition>
    </VContentBox>
  </div>
</template>
